<template>
  <nav
    class="bb bg-animate fixed h3 mw-100 top-0 w-100 white z-999"
    :class="{ 'b--gold bg-offwhite warm-black': (!scrollIsHome || menuIsOpen), 'b--transparent': scrollIsHome }">
    <div
      class="center flex h-100 items-center justify-between ph3 w-100 w-80-xl"
      :class="{ 'ts1': (scrollIsHome && !menuIsOpen) }">
      <h2
        class="bd fw3 ma0 nt2 pointer pl2 pr1 tracked ttu z-999"
        @click="jumpToId('top')">Pico</h2>

      <!-- mobile 🍔 -->
      <div
        class="hamburger flex dn-l justify-center flex-column h-100 z-999"
        @click="menuIsOpen = !menuIsOpen">
        <div
          class="hamburger-bar"
          :class="menuClass"/>
        <div
          class="hamburger-bar"
          :class="menuClass"/>
        <div
          class="hamburger-bar"
          :class="menuClass"/>
      </div>

      <transition name="fade">
        <div
          v-if="menuIsOpen"
          class="absolute bg-offwhite flex flex-column justify-center left-0 ph3 top-0 vh-100 w-100">
          <ul class="f3 list ma0 pa0 warm-black">
            <li
              class="mb4"
              @click="jumpToId('productivity')">Productivity &amp; Entertainment</li>
            <li
              class="mb4"
              @click="jumpToId('features')">Power &amp; Performance</li>
            <li
              class="mb4"
              @click="jumpToId('quality')">Quality &amp; Reliability</li>
            <li
              class="mb4"
              @click="jumpToId('contact')">Sales &amp; Rentals</li>
            <li @click="jumpToId('footer')">From Ideum</li>
          </ul>
        </div>
      </transition>

      <!-- desktop nav links -->
      <ul class="dn f6 flex-l justify-end list ma0 pa0 tracked ttu w-80 w-100-xl">
        <li
          class="mr4 pointer"
          @click="jumpToId('productivity')">Productivity &amp; Entertainment</li>
        <li
          class="mr4 pointer"
          @click="jumpToId('features')">Power &amp; Performance</li>
        <li
          class="mr4 pointer"
          @click="jumpToId('quality')">Quality &amp; Reliability</li>
        <li
          class="mr4 pointer"
          @click="jumpToId('contact')">Sales &amp; Rentals</li>
        <li
          class="pointer"
          @click="jumpToId('footer')">From Ideum</li>
      </ul>
    </div>
  </nav>
</template>

<script>
import jump from 'jump.js'

export default {
  name: 'TheNavbar',

  data () {
    return {
      menuIsOpen: false,
      scrollIsHome: true
    }
  },

  computed: {
    menuClass () {
      return {
        'is-open': this.menuIsOpen,
        'is-closed': !this.menuIsOpen
      }
    }
  },

  methods: {
    checkScrollPos () {
      const scrollY = document.body.scrollTop || window.pageYOffset
      scrollY > 0 ? this.scrollIsHome = false : this.scrollIsHome = true
    },
    jumpToId (id) {
      if (this.menuIsOpen) {
        this.menuIsOpen = false
      }
      jump(`#${id}`)
    }
  },

  mounted () {
    window.addEventListener('scroll', this.checkScrollPos)
    this.checkScrollPos()
  }
}
</script>

<style lang="scss" scoped>
h2 {
  &::after {
    transition: all .6s var(--ease-cubic);
  }
  &:hover {
    &::after {
      background-color: transparent;
      border: 1px solid var(--gold);
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}

li {
  transition: all .15s var(--ease-cubic);
  &:hover {
    color: var(--gold);
  }
}

.hamburger {
  cursor: pointer;
  width: 40px;
}

.hamburger-bar {
  background-color: var(--tan);
  margin-bottom: 6px;
  width: 40px;
  height: 4px;
  transition: all .15s ease-in-out;
  &.is-open:first-child {
    background-color: var(--gold);
    transform: rotate(45deg) translateY(14px);
  }
  &.is-open:nth-child(2) {
    opacity: 0;
  }
  &.is-open:last-child {
    background-color: var(--gold);
    transform: rotate(-45deg) translateY(-14px);
  }
  &.is-closed:first-child {
    transform: rotate(0) translate(0);
  }
  &.is-closed:nth-child(2) {
    opacity: 1;
  }
  &.is-closed:last-child {
    transform: rotate(0) translate(0);
  }
}
</style>
